
export const environment = {
    production: false,
    development: true,
    local: false,

    API_SERVER_URL: 'https://digecur-api-beta.mypeopleapps.com',

    TIPOLOGIA_ID_CICLO:160742,
    TIPOLOGIA_ID_ROLES:160730,
    TIPOLOGIA_PALABRAS_CLAVE:160738,
    TIPOLOGIA_ID_DEPENDENCIA:160734,
    ESTADO_USUARIO_ACTIVO:160445,
    ESTADO_USUARIO_INACTIVO: 160446,
    TIPOLOGIA_ID_LECTOR: 160750,
    TIPOLOGIA_ID_TIPO_PROFESIONAL:160759,
    TIPOLOGIA_ID_TIPO_MODALIDAD: 160752,
    TIPOLOGIA_ID_CICLO_DIVERSIFICADO:160744,
    // Tipologías por ciclo
    TIPOLOGIA_ID_AREA_CARRERA_BASICO: 160763,
    TIPOLOGIA_ID_ORIENTACION_OCUPACIONAL_BASICO: 160765,
    TIPOLOGIA_ID_SUBAREA_BASICO: 160769,
    TIPOLOGIA_ID_ORIENTACION_BASICO: 160773,
    TIPOLOGIA_ID_AREA_CARRERA_DIVERSIFICADO: 160764,
    TIPOLOGIA_ID_CARRERA_DIVERSIFICADO: 160778,
    TIPOLOGIA_ID_ORIENTACION_OCUPACIONAL_DIVERSIFICADO: 160766,
    TIPOLOGIA_ID_SUBAREA_DIVERSIFICADO: 160770,
    TIPOLOGIA_ID_ORIENTACION_DIVERSIFICADO: 160774,

    TIPOLOGIA_ID_CARRERA_PUBLICADA:160747

}
